<template>
  <div class="w-100" v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh"></div>
</template>
<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: 'column-break',
  mixins: [checkPermissions],
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  }
}
</script>
